<template>
  <SeoPage page-key="videoMarketingTicino" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'VideoMarketingTicinoPage'
})
</script>

